const key = 'vuex'

function setAppUserInfoStorage(value) {
  if (typeof value === 'object') {
    value = JSON.stringify(value)
  }
  localStorage.setItem(key, value)
}

function getAppUserInfoStorage() {
  const data = localStorage.getItem(key)
  if (data) {
    return JSON.parse(data)
  }
  return null // 如果没有参数，返回 null
}

function setCreateTime() {
  const appUserInfo = getAppUserInfoStorage(key)
  setAppUserInfoStorage({
    ...appUserInfo,
    createTime: Date.now(),
  })
}

// vt_android 安卓 app 的标识
// vt_iOS ios app 的标识
const isAppUserAgent = () => {
    const ua = navigator.userAgent
    return ua.includes('_android') || ua.includes('_iOS')
  }

const isAppH5 = () => {
  return getAppUserInfoStorage() && isAppUserAgent()
}

export {
  setAppUserInfoStorage,
  getAppUserInfoStorage,
  isAppH5,
  isAppUserAgent,
  setCreateTime,
}
